import React, {createContext, useEffect, useState} from 'react';
import {useQuery} from '@apollo/client';

import {THIS_USER} from '../queries/GraphQLQueries';
import {CustomRoles} from '../helpers/CustomRoles';
import {assignedRolesVar} from '../config/Cache';

export const CurrentUserContext = createContext();

export const CurrentUserProvider = ({children}) => {

    const [currentUser, setCurrentUser] = useState(null);
    const {loading, data} = useQuery(THIS_USER, {
        onCompleted: data => {
            cacheAssignedRolesInMemory(data);
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {

        if (data && data.me) {
            setCurrentUser(data.me);
        }

    }, [data]);

    const cacheAssignedRolesInMemory = (user) => {
        let roles = [];

        const profile = user.me;

        if (profile.canAdmin) {
            roles.push(CustomRoles.Admin)
        }

        if (profile.canTeach) {
            roles.push(CustomRoles.Teacher)
        }

        if (profile.canContentManage) {
            roles.push(CustomRoles.ContentManager)
        }

        if (profile.canCustomerSupport) {
            roles.push(CustomRoles.CustomerSupport)
        }

        if (profile.canTrafficManage) {
            roles.push(CustomRoles.TrafficManager)
        }

        if (profile.canLiveOps) {
            roles.push(CustomRoles.LiveOperations)
        }

        if (profile.canQA) {
            roles.push(CustomRoles.QA)
        }

        assignedRolesVar(roles);
    }

    return (
      <CurrentUserContext.Provider value={{currentUser, loading}}>
          {children}
      </CurrentUserContext.Provider>
    );
};
